import { RootState } from 'editor/src/store/index';

// the buyer's session override wins; otherwise fall back to the host-provided default
const getResolvedGapMm = (state: RootState) => state.gangSheet.gapMm ?? state.hostSettings.gangSheet?.defaultGapMm;

export default getResolvedGapMm;
